import { StyledWhatsNewContainer } from './styles'

const JoyrideTooltip = (props: any) => {
  const {
    index,
    size,
    step,
    isLastStep,
    tooltipProps,
    primaryProps,
    skipProps,
  } = props

  const showActions = step?.action_allowed !== false

  return (
    <StyledWhatsNewContainer {...tooltipProps}>
      <div className="whatsNew-steps">{`${index + 1}/${size}`}</div>
      {step.title && <div className="whatsNew-title">{step.title}</div>}
      {step.content && (
        <div className="whatsNew-body">
          {step.content.split('\n').map((line: string, i: number) => (
            <span key={i}>
              {i > 0 && <br />}
              {line}
            </span>
          ))}
        </div>
      )}
      {showActions && (
        <div className="whatsNew-footer">
          {!isLastStep && (
            <button {...skipProps} type="button" className="whatsNew-close">
              Close
            </button>
          )}
          <button {...primaryProps} type="button" className="whatsNew-next">
            {isLastStep ? 'Close' : 'Next'}
          </button>
        </div>
      )}
    </StyledWhatsNewContainer>
  )
}

export default JoyrideTooltip
